<!-- 组件说明 -->
<template>
  <div class="register-box">
    <div class="register">
      <h3>申请账号</h3>
      <el-form
        :rules="registerFormRules"
        class="demo-ruleForm"
        :model="registerForm"
        ref="registerForm"
      >
        <el-form-item prop="name">
          <el-input placeholder="请输入企业名称" v-model="registerForm.name">
            <i slot="prefix"> 企业名称 </i>
          </el-input>
        </el-form-item>

        <el-form-item class="typeBox">
          <el-input>
            <i slot="prefix"> 企业类型 </i>
          </el-input>
          <el-select v-model="value" placeholder="请选择" class="select">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.name"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="address">
          <el-input placeholder="请输入详细地址" v-model="registerForm.address">
            <i slot="prefix"> 详细地址 </i>
          </el-input>
        </el-form-item>
        <el-form-item prop="contact">
          <el-input
            placeholder="请输入联系人姓名"
            v-model="registerForm.contact"
          >
            <i slot="prefix"> 联系人 </i>
          </el-input>
        </el-form-item>
        <el-form-item prop="number">
          <el-input
            placeholder="请输入手机号码"
            maxlength="11"
            v-model="registerForm.number"
          >
            <i slot="prefix"> 手机号码 </i>
          </el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-input
            class="check"
            placeholder="请输入验证码"
            v-model="registerForm.code"
          >
            <i slot="prefix"> 验证码 </i>
          </el-input>
          <div class="getCode c-pointer active">
            <span v-show="show" @click="getCode">获取验证码</span>
            <span v-show="!show" class="count">还剩 {{ count }} s</span>
          </div>
        </el-form-item>
      </el-form>
      <div class="xieyi">
        <el-checkbox v-model="checked"></el-checkbox>
        <span
          >我接受
          <span @click="treaty(1)" class="span1">《用户注册协议》</span> 及
          <span class="span1" @click="treaty(2)">《隐私政策》</span>
        </span>
      </div>

      <div class="loginBtn c-pointer" @click="applycount('registerForm')">
        申请
      </div>
    </div>

    <success v-if="successShow">{{ message }}</success>
    <error v-if="errorShow">{{ message }}</error>
  </div>
</template>

<script>
import md5 from "js-md5";
import axios from "axios";

export default {
  components: {},
  data() {
    let contactCode = (rule, value, callback) => {
      if (!value) {
        this.cangetCode = false;
        return callback(new Error("请输入手机号码"));
      }
      let reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/; // 手机号正则验证
      let phoneNum = this.registerForm.number; // 输入手机号的value

      if (!phoneNum) {
        this.cangetCode = false;
        return callback(new Error("手机号不能为空"));
      }
      if (!reg.test(phoneNum)) {
        // 手机号不合法
        this.errorShow = true;
        this.message = "您输入的手机号码不合法，请重新输入";
        this.cangetCode = false;
        return;
      }

      this.cangetCode = true;
    };
    return {
      show: true, //获取验证码   还是倒计时
      count: "", //验证码倒计时
      timer: null, //验证码间隔时间
      registerForm: {
        name: "", //企业名称
        address: "", //地址
        contact: "", //联系人
        number: "", //手机号
        code: "", //验证码
      },

      registerFormRules: {
        number: [{ validator: contactCode, trigger: "blur" }],
        name: [{ required: true, message: "请输入企业名称", trigger: "blur" }],
        address: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
        ],
        contact: [{ required: true, message: "请输入联系人", trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      successShow: false,
      errorShow: false,
      message: "",
      options: [],
      value: "",
      checked: false,
      cangetCode: false,
    };
  },
  watch: {},
  computed: {},
  created() {
    this.getTypeList();
  },
  methods: {
    getTypeList() {
      this.$api.GET_COMPANYTYPE().then((res) => {
        if (res.status) {
          this.options = res.data;
        }
      });
    },
    treaty(type) {
      if (type == 1) {
        this.$router.push({ name: "helpcenter", query: { id: 33 } });
      } else {
        this.$router.push({ name: "helpcenter", query: { id: 32 } });
      }
    },
    //获取验证码
    async getCode() {
      var sms;
      var md5sms;
      //生成短信码
      await this.$api.GET_SMS().then((res) => {
        if (res.status) {
          sms = res.data;
          md5sms = md5(md5(sms));
        }
      });

      //发送验证码至用户手机
      await this.$api
        .GET_SENDSMS({
          mobile: this.registerForm.number,
          random: sms,
          token: md5sms,
        })
        .then((res) => {
          if (!res.status) {
            this.errorShow = true;
            this.message = "发送短信验证码失败";
            return;
          }

          this.successShow = true;
          this.message = "发送短信验证码成功";
          this.cangetCode = false;

          const TIME_COUNT = 60;
          if (!this.timer) {
            this.count = TIME_COUNT;
            this.show = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
              } else {
                this.show = true;
                clearInterval(this.timer);
                this.cangetCode = true;
                this.timer = null;
              }
            }, 1000);
          }
        })
        .catch((error) => {
          //console.log(error);
        });
    },
    applycount() {
      if (!this.checked) {
        //console.log(this.checked);
        this.errorShow = true;
        this.message = "请勾选用户协议";
        return;
      }

      this.$api
        .POST_USERREGISTER({
          address: this.registerForm.address,
          company: this.registerForm.name,
          contact: this.registerForm.contact,
          mobile: this.registerForm.number,
          code: this.registerForm.code,
          type: this.value,
        })
        .then((res) => {
          if (!res.status) {
            this.successShow = true;
            this.message = "申请账号失败";
          } else {
            this.successShow = true;
            this.message = "申请账号成功！";
            (this.registerForm.address = ""),
              (this.registerForm.name = ""),
              (this.registerForm.contact = ""),
              (this.registerForm.number = ""),
              (this.registerForm.code = "");
            this.value = "";
          }
        });
    },
    success() {
      this.successShow = false;
    },
    error() {
      this.errorShow = false;
    },
  },
  mounted() {},
};
</script>

<style lang='scss' scoped>
.register-box {
  position: absolute;
  right: 0;
  top: 100px;
  width: 390px;
  height: 560px;
  border-radius: 4px;
  box-shadow: 0 0 10px 10px #f6f6f6;
  border-top: 5px solid #f43737;
  background-color: #ffff;
  .register {
    width: 322px;
    margin: 0 auto;
    h3 {
      font-size: 22px;
      margin: 36px 0 28px 0;
      color: #333333;
    }
    .loginBtn {
      display: block;
      height: 40px;
      background-color: #fa4b4b;
      border-radius: 2px;
      margin-top: 15px;
      @include font(16px, #ffffff, center, 400, 40px);
    }
  }
}
>>> .el-input--prefix .el-input__inner {
  padding-left: 100px;
  border: 1px solid #dcdfe6 !important;
}
>>> .el-input__prefix {
  width: 77px;
  text-align-last: justify;
  i {
    border-right: 1px solid #b2b2b2;
    width: 100%;
    padding: 0 10px;
    color: #333333;
  }
}
.check {
  width: 206px;
}
.getCode {
  display: inline-block;
  width: 97px;
  margin-left: 14px;
  border: 1px solid #b2b2b2;
  border-radius: 4px;
  @include font(14px, #b2b2b2, center, 400, 40px);
}
.active {
  color: #f43737;
  border-color: #f43737;
}
.demo-ruleForm {
  margin-bottom: 10px;
}
.select {
  position: absolute;
  right: 0;
  top: 0;
  width: 240px;
}
>>> .el-input__inner {
  background-color: transparent;
  border: none;
}
.typeBox {
  position: relative;
}
.xieyi {
  span {
    font-size: 12px;
    color: #83868a;
  }
}
.span1 {
  cursor: pointer;
  &:hover {
    color: #3799f4;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/login/components/register.vue